import React from "react";
import { HashLoader } from "react-spinners";

const SmallLoader = () => {
  return (
    <div className="small_loading">
      <div className="d-flex justify-content-center">
        <HashLoader size={20} color="#21232f" />
      </div>
    </div>
  );
};

export default SmallLoader;
